export const LOADING_LEAVETYPE = "LOADING_LEAVETYPE";
export const GET_LEAVETYPE_LIST = "GET_LEAVETYPE_LIST";
export const GET_LEAVETYPEBYID = "GET_LEAVETYPEBYID";
export const REMOVE_LEAVETYPE = "REMOVE_LEAVETYPE";
export const ADD_LEAVETYPE = "ADD_LEAVETYPE";
export const UPDATE_LEAVETYPE = "UPDATE_LEAVETYPE";